import React,{useState,useEffect} from "react";
import API from "../../../utils/API";
import Categoryitem from "./CategoryItem";
import {AiFillDelete} from "react-icons/ai";
import {confirmAlert} from 'react-confirm-alert';

const Categories = ({appId}) => {

    const [list,setList] = useState([])
    const [editCategory, setEditCategory] = useState(false)
    const [editCategoryId, setEditCategoryId] = useState(null)

    const newCategory = () => {
        setEditCategoryId(null)
        setEditCategory(true)
    }

    const closeEditCategory = () => {
        setEditCategoryId(null)
        setEditCategory(false)
        loadList()
    }

    const deleteItem = (id) => {
        confirmAlert({
            title: 'Confirm to delete',
            message: 'Are you sure you want to delete this category?',
            buttons: [
                {
                    label: 'Yes',
                    onClick: () => {
                        API.delete(`/ecommerce/category/${appId}/${id}`).then((result)=>{
                            loadList()
                        })
                    }
                },
                {
                    label: 'No',
                    onClick: () => {}
                }
            ]
        });
    }

    const startEditCategory = (id) => {
        setEditCategoryId(id)
        setEditCategory(true)
    }

    const loadList = () => {
        API.post(`/ecommerce/categories/${appId}`).then((result)=>{
            setList(result.data.data)
        })
    }

    useEffect(()=>{
        loadList()
    },[])

    return (<>
        <div className="m-2">
            <div className="header">
                <div className="row justify-content-between">
                    <div className="col-auto pt-2">
                        {editCategory ?
                            <>
                                {editCategoryId ?
                                    <>Edit category</>
                                    :
                                    <>New category</>
                                }
                            </>
                            :
                            <>Product categories</>
                        }
                    </div>
                    <div className="col-auto">
                        {!editCategory &&
                            <div className="primaryButton" onClick={()=>newCategory()}>+ New Category</div>
                        }
                    </div>
                </div>
            </div>
        </div>
        {editCategory ?
            <Categoryitem id={editCategoryId} app={appId} onClose={closeEditCategory}/>
            :
            <>
                {
                    list?.map((item,key)=>{
                        return <div key={key} className="categoryType">
                            <div className="row">
                                <div className="col" onClick={()=>startEditCategory(item.id)}>
                                    <span>{item.title}</span>
                                </div>
                                <div className="col-auto" onClick={()=>deleteItem(item.id)}>
                                    <AiFillDelete/>
                                </div>
                            </div>
                        </div>
                    })
                }
            </>
        }
    </>)
}

export default Categories